import { useContext, useEffect, useState } from "react";
import { ToolContext } from "../../../../../../core/context/ToolContext";
import { JoyrideWrapper } from "../../JoyrideWrapper";

export const BookingCheckIn = ({ end }) => {
	const {personalization_state} = useContext(ToolContext)
	const {walkthrough, startHere} = personalization_state
	const [firstStepReady, setFirstStepReady] = useState(false);
	const tab = new URLSearchParams(window.location.search).get('tab')

	const endTour = ()=>{
		walkthrough.set((p) => ({ ...p, bookingCheckIn: false}))
		startHere.set((p) => ({ ...p, show: true}))
		setFirstStepReady(false)
	}

	const steps = [
		{
			target: '.bookingCheckInFirstStep',
			title: "View Order",
			content: 'Click to view booking details.',
			disableBeacon: true,
			placement: "left",
		},
		{
			target: '.bookingCheckInSecondStep',
			title: "Move to Check-Out",
			content: 'Click to move this booking to check-out.',
			disableBeacon: true,
			placement: "left",
			modalTriggers: 'bookingCheckIn'
		},
	]

	useEffect(() => {
		const interval = setInterval(() => {
			const el = document.querySelector('.bookingCheckInFirstStep');
			if (el) {
				clearInterval(interval);
				setFirstStepReady(true);
			}
		}, 100);
		return () => clearInterval(interval);
	}, [tab, walkthrough.data.bookingCheckIn]);

	return (
		firstStepReady && 
		<JoyrideWrapper 
			run={Boolean(walkthrough.data.bookingCheckIn)} 
			steps={steps} 
			setter={endTour} 
			end={end}
			p_name="bookingCheckIn" 
			featureName="sales"
		/>
	);
}
